module.exports = __webpack_public_path__ + "33264a976c55427b454989707d50913b.svg";